export default function formInputAnimate() {
  $('.form-control').each(function() {
    let formFieldPlaceholder = $(this).attr('placeholder');
    $(this).after(`<span class="form-label">${formFieldPlaceholder}</span>`);
    $(this).focus(function(){
      $(this).parent().addClass('has-val');
    });
    $(this).blur(function(){
        $(this).val() != ''
        ? $(this).parent().addClass('has-val')
        : $(this).parent().removeClass('has-val');
    });
  });
};
